/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ muscle: NonNullable<unknown> }} Prescription_Reason_PopularInputs */

const en_us2_prescription_reason_popular = /** @type {(inputs: Prescription_Reason_PopularInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A well-tested pick for ${i?.muscle}`)
};

const pt_br2_prescription_reason_popular = /** @type {(inputs: Prescription_Reason_PopularInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uma escolha consagrada para ${i?.muscle}`)
};

const es_419_prescription_reason_popular = /** @type {(inputs: Prescription_Reason_PopularInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Una opción probada para ${i?.muscle}`)
};

const pt_pt2_prescription_reason_popular = /** @type {(inputs: Prescription_Reason_PopularInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uma escolha consagrada para ${i?.muscle}`)
};

const fr_fr2_prescription_reason_popular = /** @type {(inputs: Prescription_Reason_PopularInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Un choix éprouvé pour ${i?.muscle}`)
};

const de_de2_prescription_reason_popular = /** @type {(inputs: Prescription_Reason_PopularInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eine bewährte Wahl für ${i?.muscle}`)
};

const it_it2_prescription_reason_popular = /** @type {(inputs: Prescription_Reason_PopularInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Una scelta collaudata per ${i?.muscle}`)
};

/**
* | output |
* | --- |
* | "A well-tested pick for {muscle}" |
*
* @param {Prescription_Reason_PopularInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const prescription_reason_popular = /** @type {((inputs: Prescription_Reason_PopularInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prescription_Reason_PopularInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_prescription_reason_popular(inputs)
	if (locale === "es-419") return es_419_prescription_reason_popular(inputs)
	if (locale === "pt-PT") return pt_pt2_prescription_reason_popular(inputs)
	if (locale === "fr-FR") return fr_fr2_prescription_reason_popular(inputs)
	if (locale === "de-DE") return de_de2_prescription_reason_popular(inputs)
	if (locale === "it-IT") return it_it2_prescription_reason_popular(inputs)
	return en_us2_prescription_reason_popular(inputs)
});
export { prescription_reason_popular as "prescription.reason.popular" }